module.exports = __webpack_public_path__ + "images/emoji/cow.ba29266237a2410659cf.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/cow.png
// module id = iayo
// module chunks = 1